/**
 * What a map feature is CALLED on screen, as opposed to what its row is named.
 *
 * Every public way in is just "Entrance" (operator, 2026-09-25: not "Main Entrance", not "North Entrance").
 * A restricted door keeps its name - "VIP entrance" tells a GA ticket-holder not to queue there, which is the
 * same reason the Entrance chip skips it (operator, 2026-09-23).
 */

export const RESTRICTED_ENTRANCE =
  /\b(vip|artist|staff|crew|media|press|backstage|guest ?list|platinum|premier|ada|accessib|hospitality|vendor|production|will ?call)\b/i;

export function isPublicEntrance(f) {
  if (!f) return false;
  const kind = f.kind ?? f._kind;
  const entrance = kind === 'entrance' || (f.type === 'gate' && !kind); // a gate is an entrance unless it says it is an exit
  return entrance && !RESTRICTED_ENTRANCE.test(`${f.name || ''} ${f.std || ''}`);
}

/** The on-screen name: "Entrance" for any public entrance, else the feature's own (std beats name in the scene). */
export function featureDisplayName(f, fallback = '') {
  if (!f) return fallback;
  if (isPublicEntrance(f)) return 'Entrance';
  return f.std || f.name || fallback;
}
